import { render, staticRenderFns } from "./Unauthorised.vue?vue&type=template&id=6d9fe559&"
import script from "./Unauthorised.vue?vue&type=script&lang=js&"
export * from "./Unauthorised.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports